export const listTemplates = '/products/sold'

export const templatePage = (templateId: string): string =>
	`${listTemplates}/${templateId}`
